import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Link from '@magalu/stereo-ui/atoms/Link';
import { getTextColor, themeGet } from '@magalu/stereo-ui-styles';
export var ShowMore = styled(Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", "px;\n  margin-top: ", "px;\n  float: right;\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), function (props) {
  return getTextColor('primary')(props);
}, themeGet('fontSizes.2'), themeGet('space.2'));